import {getContainer} from '../utils/utils.js';

type WindowBrowserClient = {
  APPLICATION_EVENTS: {
    WINDOW: {
      SELECT_WINDOW: {topic: string};
      CLOSE_WINDOW: {topic: string};
    };
  };
  browserContextId: string;
  broadcast: (topic: string, data: unknown) => Promise<void>;
  publish: (topic: string, data: unknown) => void;
};

const getWindowBrowserClient = (): WindowBrowserClient =>
  getContainer().applicationClient as unknown as WindowBrowserClient;

export const onWindowSelected = async (windowId: string) => {
  const browserClient = getWindowBrowserClient();
  const browserContextId = String(browserClient.browserContextId);

  await browserClient.broadcast(
    browserClient.APPLICATION_EVENTS.WINDOW.SELECT_WINDOW.topic,
    {
      browserContextId,
      windowId,
    },
  );
};

export const onWindowClosed = async (windowId: string) => {
  const browserClient = getWindowBrowserClient();
  const browserContextId = String(browserClient.browserContextId);

  browserClient.publish(browserClient.APPLICATION_EVENTS.WINDOW.CLOSE_WINDOW.topic, {
    browserContextId,
    windowId,
  });
};
